import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/index';
import { Grid, Typography, OutlinedInput, FormControl, InputLabel, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
//import Input from '../../../components/UI/Input';
import { withStyles } from '@material-ui/core/styles';
import 'react-square-payment-form/lib/default.css';
import ProcessingDialog from '../../../components/Checkout/ProcessingDialog/ProcessingDialog';
import CheckoutTab from '../../../components/Checkout/CheckoutTab/CheckoutTab';
import CheckoutComplete from '../../../components/Checkout/CheckoutComplete/CheckoutComplete';
import CheckoutForm from '../../../components/Checkout/CheckoutForm/CheckoutForm';
import Input from '../../../components/UI/Input';
import moment from 'moment';
import { functions } from '../../../../firebase/firebase';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',

        "& .MuiFormLabel-root": {
            color: "grey",
        },

        "& .MuiInputBase-input": {
            color: "black",
        },
    },

    container: {
        maxWidth: '1200px',
        display: 'flex',
        justifyContent: 'center',
        margin: theme.spacing(2),

        [theme.breakpoints.down('xs')]: {

            alignItems: 'center',
            margin: '0px',
        },
    },

    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(4),
    },

    checkout: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: theme.spacing(3),
        width: '250px',
    }
});

const Checkout = (props) => {
    const { cart, validLocation, history, getCheckout, paymentComplete, resetCart } = props;
    const [checkoutError, setCheckoutError] = useState([])
    const [processing, setProcessing] = useState(false)
    const [paymentErrors, setPaymentErrors] = useState([])
    const [accepted, setAccepted] = useState(false);
    const [payingHalf, setPayingHalf] = useState(false);

    const sendSquarePayment = functions.httpsCallable('createSquarePaymentLink');

    //FIND OUT WHAT GETCHECKOUT DOES, navigates when cart empty?
    useEffect(() => {
        const isDelivery = cart.filter(item => item.shippingMethod === 'Delivery' || item.shippingMethod === 'Installation').length > 0;
        if (isDelivery && !validLocation)
            history.push({
                pathname: '/cart/',
            })
        getCheckout();
    }, [cart, getCheckout, history, validLocation])

    //navigates on completion
    useEffect(() => {
        if (paymentComplete) {
            //setDisableCheckout(false);
            resetCart();
            sessionStorage.setItem('cartStep', JSON.stringify(0));

            history.push({
                pathname: '/cart/checkout/complete',
            })
        }
    }, [paymentComplete, resetCart, history])

    useEffect(() => {
    }, [props.checkoutForm])

    const inputChangedHandler = (event, inputIdentifier) => {
        const updatedCheckoutForm = {
            ...props.checkoutForm
        };
        const updatedFormElement = {
            ...updatedCheckoutForm[inputIdentifier]
        };

        //Update changed value and add to reducer
        updatedFormElement.value = event.target.value;
        //console.log(updatedFormElement.value)
        //props.checkoutForm.preferredContactMethod === 'Text Message'
        updatedCheckoutForm[inputIdentifier] = updatedFormElement;

        props.updateCheckoutForm(updatedCheckoutForm);
    }
    
    const validateCheckoutFields = (event) => {
        //event.preventDefault()
        
        const emailPattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        const phonePattern = /[0-9]{3}-[0-9]{3}-[0-9]{4}/;
        let isValid = true;
        let container = []

        Object.keys(props.checkoutForm).forEach((key, value) => {
            if (props.checkoutForm[key].value === '' && props.checkoutForm[key].elementConfig.required === true
                ){
                container.push('All fields marked with * are required.')
                isValid = false;
            }
            if (props.checkoutForm[key].elementConfig.type === 'email' && props.checkoutForm.preferredContactMethod.value !== 'Text Message'){
                !emailPattern.test(props.checkoutForm[key].value.toLowerCase()) && container.push('Must be a valid email format.')
                isValid = emailPattern.test(props.checkoutForm[key].value.toLowerCase()) && isValid;
            }
            if (props.checkoutForm[key].elementConfig.type === 'confirmEmail' && props.checkoutForm.preferredContactMethod.value !== 'Text Message'){
                props.checkoutForm['email'].value.toLowerCase() !== props.checkoutForm[key].value.toLowerCase() && container.push('Emails must match.')
                isValid = props.checkoutForm['email'].value.toLowerCase() === props.checkoutForm[key].value.toLowerCase() && isValid;
            }
            //WITH THIS SOME CUSTOMERS HAVE TROUBLE INPUTTING - INTO THEIR PHONE NUMBERS BECAUS THEYRE STUPID LMAO
            if (props.checkoutForm[key].elementConfig.type === 'phone') {
                !phonePattern.test(props.checkoutForm[key].value) && container.push('Must be a valid phone number format.')
                isValid = phonePattern.test(props.checkoutForm[key].value) && isValid;
            }
        })

        setCheckoutError(container)
        return isValid;
    }

    const createInput = (data) => {
        return (
            data.config.elementType === 'select'?
            <Input
                key={data.id}
                elementType={data.config.elementType}
                elementConfig={data.config.elementConfig}
                value={data.config.value}
                variant='outlined'
                changed={(event) => inputChangedHandler(event, data.id)} />
            : data.config.elementType !== 'radio' ?
        <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" 
        style={props.checkoutForm.preferredContactMethod.value === 'Text Message' && data.config.elementConfig.label.includes('Confirm Email')?{display:'none'}:{}}
        required={props.checkoutForm.preferredContactMethod.value === 'Text Message' && data.config.elementConfig.label.includes('Email') ? false : true}>
            <InputLabel htmlFor={data.id}>{data.config.elementConfig.label}</InputLabel>
            <OutlinedInput
                autoComplete={data.autoComplete}
                id={data.id}
                name={data.name}
                label={data.config.elementConfig.label}
                key={data.id}
                elementType={data.config.elementType}
                elementConfig={data.config.elementConfig}
                value={data.config.value}
                variant='outlined'
                onChange={(event) => inputChangedHandler(event, data.id)} />
        </FormControl>
        :
        <RadioGroup id={data.id} name={data.name} key={data.id} elementType={data.config.elementType} elementConfig={data.config.elementConfig} label={data.config.elementConfig.label}
        defaultValue={'Email'} value={data.config.elementConfig.value} onChange={(event) => inputChangedHandler(event, data.id)}>
            {data.config.elementConfig.options.map((option, index) => {
                return (
                    <FormControlLabel key={index} value={option.value} control={<Radio />} label={option.label} />                
                )
            })}
        </RadioGroup>
        )
    }

    const onSuccessfulPayment = (paymentResults, halfResults) => {
        console.log(halfResults)
        let payment = !paymentResults ? 
        {
            paymentHandler: "SQUARE",
            amount_money: {
                amount: 0.00,
                currency: "CAD"
            },
            approved_money: {
                amount: 0.00,
                currency: "CAD"
            },
            card_details: {
                card: props.cartFees.giftCardApplied > 0 ? 
                {
                    card_brand: "GEE TEE GIFT CARD",
                    card_type: "GIFT CARD",
                    exp_date: "N/A",
                    last_4: "************"+props.cartFees.giftCards[0].code.substring(props.cartFees.giftCards[0].code.length - 4),
                }
                : {}
            },
            //subtract one hour to account for the shitty bandaid which adds an hour in orderTable.js
            created_at: moment().subtract(1, 'hours').format('MM/DD/YYYY hh:mm:ss a'),
            
            id: props.cartFees.giftCardApplied > 0 ? 'NO_PAYMENT_ID_GIFT_CARD_COVERED_ENTIRE_PAYMENT' : 'NO_PAYMENT_ID_NO_PAYMENT_PROVIDED',
        }
        
        :
        {
            paymentHandler: "SQUARE",
            amount_money: {
                amount: paymentResults.amountMoney.amount || 0.00,
                currency: "CAD"
            },
            approved_money: {
                amount: paymentResults.approvedMoney.amount || 0.00,
                currency: "CAD"
            },
            card_details: {
                card: {
                    card_brand: paymentResults.cardDetails.card.cardBrand,
                    card_type: paymentResults.cardDetails.card.cardType,
                    exp_date: paymentResults.cardDetails.card.expMonth.toString() + paymentResults.cardDetails.card.expYear.toString().substring(2),
                    last_4: "************" + paymentResults.cardDetails.card.last4,
                }
            },
            created_at: paymentResults.createdAt,
            id: paymentResults.id,
            customer_id: halfResults?.customerId,
            card_id: halfResults?.cardId,
            second_half : !halfResults ? null : {
                paymentHandler: "SQUARE",
                amount_money: {
                    amount: halfResults.amountMoney.amount || 0.00,
                    currency: "CAD"
                },
                approved_money: {
                    //amount: halfResults.approvedMoney.amount || 0.00,
                    currency: "CAD"
                },
                card_details: {
                    card: {
                        card_brand: halfResults.cardDetails.card.cardBrand,
                        card_type: halfResults.cardDetails.card.cardType,
                        exp_date: halfResults.cardDetails.card.expMonth.toString() + halfResults.cardDetails.card.expYear.toString().substring(2),
                        last_4: "************" + halfResults.cardDetails.card.last4,
                    }
                },
                created_at: halfResults.createdAt,
                id: halfResults.id,
                customer_id: halfResults.customerId,
                card_id: halfResults.cardId,
                status: halfResults.status,
            } 
        }

        let customer = {
            givenName: props.checkoutForm.firstName.value,
            familyName: props.checkoutForm.lastName.value,
            contactMethod: props.checkoutForm.preferredContactMethod.value,
            email: props.checkoutForm.email.value,
            phone: props.checkoutForm.phone.value,
            addressLines: [props.checkoutForm.address.value],
            postalCode: props.checkoutForm.postalCode.value,
            province: props.checkoutForm.province.value,
            country: props.checkoutForm.country.value,
            city: props.checkoutForm.city.value,
            destination: {
                coordinates: props.customerLocation,
                location: [props.customerAddress],
            },
        };

        let order = {
            products: [],
            paidOff: payingHalf ? false : true,
            remainingBalance: payingHalf ? props.cartFees.halfCost : 0.00,
            fees: Object.assign({}, props.cartFees),
            status: 'PROCESSING',
            notes: props.checkoutForm.notes.value,
            deliverDate: props.checkoutForm.deliverDate.value || "",
            deliverTime: props.checkoutForm.deliverTime.value || "",
        };

        if (props.shipping)
            order.shipping = props.shipping

        for (let i = 0; i < props.cart.length; i++) {
            order.products[i] = {
                product: props.cart[i].product.docId,
                productName: props.cart[i].product.name,
                variant: props.cart[i].variant,
                qty: props.cart[i].qty,
                shippingMethod: props.cart[i].shippingMethod,
                price: props.cart[i].price
            }
        }

        order.fees.total = order.fees.total.toFixed(2)
        order.fees.couponCode = props.inputCoupon
        order.fees.salesApplicable = props.coupons.sales ? props.coupons.sales.map(sale => {return sale.docId}) : [];
        order.fees.appliedDiscountCodes = props.appliedDiscountCodes;


        props.createPaymentConverge(payment, customer, order);
    }

    const handlePayment = (token) => {
        setProcessing(true);
        console.log('handlePayment', token);
        console.log('is paying half? ', payingHalf);
        // Customer information for Half Now & Half Later
        const customerInfo = payingHalf ? {
            email: props.checkoutForm.email.value,
            firstName: props.checkoutForm.firstName.value,
            lastName: props.checkoutForm.lastName.value,
            phone: props.checkoutForm.phone.value
        } : null;
        
        sendSquarePayment({
            sandbox: process.env.NODE_ENV === 'development',
            amount: Number(props.cartFees.total.toFixed(2) - Number(props.cartFees.giftCardApplied).toFixed(2)),
            token: token.token,
            halfNowHalfLater: payingHalf,
            halfCost: props.cartFees.halfCost,
            customerInfo: customerInfo // Only included for Half Now & Half Later
        })
        .then((res) => {
            // Check if the payment was successful
            if (res.data.success) {
                // Log customer and card IDs if available
                if (res.data.customerId && res.data.cardId) {
                    console.log("Customer and card created for Half Now & Half Later");
                    console.log("Customer ID:", res.data.customerId);
                    console.log("Card ID:", res.data.cardId);
                }
                
                if (res.data.data.result.payment.status === "COMPLETED") {
                    console.log("COMPLETED");
                    
                    // Pass the payment results to the success handler
                    // If there's a second payment (half later), include it
                    console.log(res.data)
                    const secondPayment = res.data.data2 ? res.data.data2.payment : null;
                    
                    // Modify the secondPayment object to include customer and card IDs
                    if (secondPayment && res.data.customerId && res.data.cardId) {
                        secondPayment.customerId = res.data.customerId;
                        secondPayment.cardId = res.data.cardId;
                    }
                    
                    onSuccessfulPayment(res.data.data.result.payment, secondPayment);
                    setProcessing(false);
                } else {
                    console.log("FAILED");
                    setPaymentErrors(res.data.data.errors || ["Payment processing failed"]);
                    setProcessing(false);
                }
            } else {
                // Payment processing failed
                console.log("PAYMENT FAILED", res.data.errors);
                setPaymentErrors(res.data.errors || ["Payment processing failed"]);
                setProcessing(false);
            }
        })
        .catch((error) => {
            console.error("Payment error:", error);
            setPaymentErrors(["An unexpected error occurred. Please try again."]);
            setProcessing(false);
        });
    };

    const { classes } = props;

    const formElementsArray = [];
    for (let key in props.checkoutForm) {

        formElementsArray.push({
            autoComplete: props.checkoutForm[key].autoComplete ? props.checkoutForm[key].autoComplete : key,
            name: props.checkoutForm[key].name ? props.checkoutForm[key].name : key,
            id: key,
            config: props.checkoutForm[key]
        });
    }

    let payForm = null;

    if (props.cart.length > 0) {
        payForm = (
            <Grid container spacing={2} className={classes.container}>
                {props.cartFees.total > 50000 && <Grid item xs={12}>
                    <Typography style={{ color: 'red' }} align='center'>
                        Caution: Orders over $50,000 currently cannot be processed online.
                        </Typography>
                </Grid>}
                <Grid item xs={12} sm={6} md={6} lg={5}>
                    <CheckoutForm
                        //cardNonceResponseReceived={cardNonceResponseReceived}
                        //createVerificationDetails={createVerificationDetails}
                        formElementsArray={formElementsArray}
                        createInput={createInput}
                        payingHalf={payingHalf} setPayingHalf={setPayingHalf}
                        accepted={accepted} setAccepted={setAccepted}
                        validateCheckoutFields={validateCheckoutFields}
                        onSuccessfulPayment={onSuccessfulPayment}
                        processingPayment={props.processingPayment}
                        inputChangedHandler={inputChangedHandler}
                        paymentFailed={props.paymentFailed} 
                        cartFees={props.cartFees}
                        checkoutError={checkoutError}
                        checkoutInfo={props.checkoutForm}
                        paymentErrors={paymentErrors}
                        handlePayment={handlePayment}
                        processing={processing} setProcessing={setProcessing}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <CheckoutTab cartFees={props.cartFees} payingHalf={payingHalf} />
                </Grid>
            </Grid>
        )
    }

    return (
        <div className={classes.root}>
            {props.paymentComplete && (props.cartFees.shipping === 0 || props.validLocation) ? <CheckoutComplete /> : payForm}
            <ProcessingDialog open={props.processingPayment} />
        </div>
    );
}

//Map slice of global state to props
const mapStateToProps = state => {
    return {
        // state refers to global state 
        // "checkout" is the name given in index.js to the state of our reducer
        cart: state.cart.cart,
        cartFees: state.cart.cartFees,
        coupons: state.cart.coupons, 
        appliedDiscountCodes: state.cart.appliedDiscountCodes,
        inputCoupon: state.cart.coupons.inputCoupon,
        checkoutForm: state.checkout.checkoutForm,
        customerAddress: state.cart.customerAddress,
        customerLocation: state.cart.customerLocation,
        distance: state.cart.distance,
        loading: state.checkout.loading,
        formSubmitted: state.checkout.formSubmitted,
        formValid: state.checkout.formValid,
        validLocation: state.cart.validLocation,
        processingPayment: state.checkout.processingPayment,
        shipping: state.cart.shipping,
        paymentComplete: state.checkout.paymentComplete,
        paymentFailed: state.checkout.paymentFailed,
        taxesLoading: state.cart.taxesLoading,
    };
}

//map our dispatch functions to props 
const mapDispatchToProps = dispatch => {
    return {
        //we collect all our "actionsCreators" into /store/actions/index.js 
        //index.js is an index of all the actions we create in /store/actions
        //the ones used below are traced back to /store/actions/products.js
        setSubtotal: () => dispatch(actionCreators.setSubtotal()),
        getTax: () => dispatch(actionCreators.getTax()),
        calcShipping: () => dispatch(actionCreators.calcShipping()),
        createPayment: (nonce, buyerVerificationToken, customer, order) => dispatch(actionCreators.createPayment(nonce, buyerVerificationToken, customer, order)),
        setPaymentFailed: (didPaymentFail) => dispatch(actionCreators.setPaymentFailed(didPaymentFail)),
        getCheckout: () => dispatch(actionCreators.getCheckout()),
        updateCheckoutForm: (formData) => dispatch(actionCreators.updateCheckoutForm(formData)),
        validateCheckout: () => dispatch(actionCreators.validateCheckout()),
        resetCart: () => dispatch(actionCreators.resetCart()),
        createPaymentConverge: (payment, customer, order) => dispatch(actionCreators.createPaymentConverge(payment, customer, order)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Checkout)));